
(function () {
    "use strict";

    var LOG = "[Custom][Free Gift] Popup skip gift line:";
    var GIFT_PROPERTY = "_salepify-bogo";
    var RENDER_DELAY_MS = 300;
    var MAX_ATTEMPTS = 6;

    function isGift(item) {
        try {
            return !!(item && item.properties && item.properties[GIFT_PROPERTY]);
        } catch (error) {
            return false;
        }
    }

    function renderPopupLines(attempt) {
        fetch("/cart.js", { headers: { Accept: "application/json" } })
            .then(function (res) {
                return res.json();
            })
            .then(function (cart) {
                var popup = document.querySelector("cart-notification-drawer");
                if (!popup || !popup.hasAttribute("open")) return;

                Array.prototype.forEach.call(popup.querySelectorAll("[data-tl-gift]"), function (line) {
                    line.remove();
                });

                var items = cart.items || [];
                var mainIndex = -1;
                var giftIndexes = [];
                items.forEach(function (item, index) {
                    if (isGift(item)) giftIndexes.push(index);
                    else if (mainIndex < 0) mainIndex = index;
                });
                if (mainIndex < 0 || !giftIndexes.length) return;

                var popupLine = popup.querySelector(".cart-drawer__line-items line-item") || popup.querySelector("line-item");
                var drawerLines = document.querySelectorAll("cart-drawer line-item");
                if (!popupLine) return;

                // Drawer chưa vẽ xong (số dòng hoặc số lượng chưa khớp giỏ thật) thì thử lại.
                var drawerFresh = drawerLines.length === items.length && [mainIndex].concat(giftIndexes).every(function (index) {
                    var input = drawerLines[index].querySelector("input");
                    return !input || Number(input.value) === Number(items[index].quantity);
                });
                if (!drawerFresh) {
                    if (attempt < MAX_ATTEMPTS) setTimeout(function () { renderPopupLines(attempt + 1); }, RENDER_DELAY_MS);
                    return;
                }

                var mainLine = drawerLines[mainIndex].cloneNode(true);
                popupLine.replaceWith(mainLine);

                var anchor = mainLine;
                giftIndexes.forEach(function (index) {
                    var giftLine = drawerLines[index].cloneNode(true);
                    giftLine.setAttribute("data-tl-gift", "1");
                    anchor.insertAdjacentElement("afterend", giftLine);
                    anchor = giftLine;
                });
            })
            .catch(function (error) {
                console.log(LOG, "render popup lines failed", error);
            });
    }

    // Capture: chạy trước handler của theme (gắn ở documentElement) để theme đọc đúng sản phẩm chính.
    document.addEventListener("cart:change", function (event) {
        try {
            var cart = event.detail && event.detail.cart;
            if (!cart || !Array.isArray(cart.items) || cart.items.length < 2 || !isGift(cart.items[0])) return;

            var mainIndex = -1;
            for (var i = 0; i < cart.items.length; i++) {
                if (!isGift(cart.items[i])) {
                    mainIndex = i;
                    break;
                }
            }
            if (mainIndex < 1) return;

            var main = cart.items[mainIndex];
            cart.items = [main].concat(cart.items.filter(function (item) {
                return item !== main;
            }));
        } catch (error) {
            console.log(LOG, "reorder items failed", error);
        }
    }, true);

    // Bubble: chờ theme vẽ xong popup và cart-drawer rồi mới dựng lại dòng.
    document.addEventListener("cart:change", function () {
        try {
            setTimeout(function () {
                try {
                    renderPopupLines(1);
                } catch (error) {
                    console.log(LOG, error);
                }
            }, RENDER_DELAY_MS);
        } catch (error) {
            console.log(LOG, error);
        }
    });
})();
